import { useState, useEffect } from "react";
import {
  BodyComponent,
  TableComponent,
  ActionComponent,
  CreateButton, RefreshButton,
  trans,
  PaginationComponent
} from "@comps/components";
import { makeRequest } from "@utils/helpers";
import { Commons, Const, colors } from "../../constants.js";
import { Space, message, Badge } from 'antd';
import { FilterComponent, FilterButton } from "@comps/components";
import { deleteDataReq, getAllDataReq, getFilterReq } from "./requests";
import { Header } from "antd/es/layout/layout";
//import CreateReligion from "./components/CreateReligion";
//import UpdateReligion from "./components/UpdateReligion";
import { convertTimeTotz } from '@comps/commonFunctions';

const langKey = Const["users"].lngKey;
const headerStyle = { background: 'white', textAlign: "right" }
const IndexUsers = (props) => {
  const totalRecords = 0;
  const [dataSource, setDataSource] = useState([]);
  const [loader, setLoader] = useState(false);
  const [childComponent, setChildComponent] = useState(null);

  const [filters, setFilters] = useState();
  //start pagination states
  const [currentPage, setCurrentPage] = useState(1)
  const [pagination, setPagination] = useState({
    "total": 0,
    "count": 0,
    "per_page": 0,
    "current_page": 0,
    "total_pages": 0,
    "links": {}
  });
  //end pagination states

  // ==================================
  //   Use States End
  // ==================================

  // ================================== UpdateLocation
  //   Table Data End
  // ==================================

  const columns = [
    {
      key: 'name',
      title: trans(Commons.name),
      dataIndex: "full_name",
    },
    {
      key: 'role_name',
      title: "Role",
      dataIndex: "role_name",
    },
    {
      key: 'email',
      title: "Email/Username",
      dataIndex: "email",
    },

    {
      key: 'status',
      title: "Status",
      render: (record) => {
        return <Badge
          count={ record.status ? record.status : 'none' }
          style={ { background: colors[record.status_class], color: colors[record.status_class + '-color'] } }
        />
      }
    },
    {
      key: 'last_activity_at',
      title: "Last Activity",
      render: (record) => {
        return record.last_activity_at ? convertTimeTotz(record.last_activity_at).format('YYYY-MM-DD hh:mm a') : ''
      }
    },
    {
      key: 'last_login_at',
      title: "Last Login",
      render: (record) => {
        return record.last_login_at ? convertTimeTotz(record.last_login_at).format('YYYY-MM-DD hh:mm a') : ''
      }
    },

    // {
    //   key: trans(Commons.actions),
    //   title: trans(Commons.actions), fixed: 'right',

    //   render: (record) => (
    //     <ActionComponent
    //       each={ record } modkey={ props.modkey }
    //       onDelete={ onDelete }
    //       onEdit={ onEdit }
    //       onView={ onView }
    //     ></ActionComponent>
    //   ),
    // },
  ];

  // ==================================
  //   Table Data End
  // ==================================

  useEffect(() => {
    getAllData();
    // eslint-disable-next-line
  }, [filters, currentPage]);

  const getAllData = () => {
    const payload = {
      page: currentPage,
      filters: filters
    }
    makeRequest(setLoader, getAllDataReq, payload, onSuccess, null);
  };

  const onSuccess = (response) => {
    setPagination(response.users);
    setDataSource(response.users.data);
  };

  const onEdit = (record) => {
    setChildComponent(
      //<UpdateReligion onCompleted={ onCompleted } record={ record } disabled={ false } />
    );
  };

  const onView = (record) => {
    setChildComponent(
      //<UpdateReligion onCompleted={ onCompleted } record={ record } disabled={ true } />
    );
  };

  const onDelete = (record) => {
    makeRequest(setLoader, deleteDataReq, record.id, onDeleted, onError);
  };
  const onDeleted = (res) => {
    onSuccess(res)
    setDataSource(res.religions.data);
    message.success("Record Deleted")
  };

  const onError = (err, res) => {
    let errorList = [];
    message.error(res.response.data.message);
    //setErrors(errorList);
  }

  // Create component modal
  const onCreate = () => {
    //setChildComponent(<CreateReligion onCompleted={ onCompleted } />);
  };

  const onCompleted = (data) => {
    if (data.length) {
      setDataSource(data);
    }
    setChildComponent(null);
  };

  const handleTableChange = (page, fil, sorter) => {
    let payload = {
      ...pagination,
      current: page.current,
      pageSize: page.pageSize,
      sortName: sorter.field || "id",
      sortType: sorter.order === "ascend" ? "asc" : "desc",
    };
    setPagination(payload);
  };

  //---------------filters-----------------------
  const onOpenFilter = () => {
    setChildComponent(<FilterComponent filters={ filterFields } modkey={ props.modkey } selected={ filters } api={ getFilterReq } setCurrentPage={ setCurrentPage } onFilter={ setFilters } onCloseFilter={ onCloseFilter }
    />
    )
  }

  const onCloseFilter = () => {
    setChildComponent(null);

  }

  //----end filter--------------------

  return (
    <>

      { childComponent }
      <BodyComponent>
        <Header style={ headerStyle }>
          <Space>
            <RefreshButton onClick={ getAllData } />
            {/* <CreateButton onClick={ onCreate } text="Add User" /> */ }
            <FilterButton onClick={ onOpenFilter } />
          </Space>

        </Header>
        <TableComponent modkey={ props.modkey }
          loader={ loader }
          columns={ columns }
          dataSource={ dataSource }
          pagination={ { ...pagination, total: totalRecords } }
          onChange={ handleTableChange }
        />
      </BodyComponent>
      <PaginationComponent pagination={ pagination } modkey={ props.modkey } setCurrentPage={ setCurrentPage } currentPage={ currentPage } />
    </>
  );
};

export default IndexUsers;
const filterFields = [
  {
    type: "text",
    placeholder: "Name",
    key: "first_last_name"
  },
  {
    type: "text",
    placeholder: "Email",
    key: "email"
  },

  {
    type: "select",
    placeholder: "Status",
    key: "is_active",
    data_key: "supporting_data.is_active",
  },
  {
    type: "select",
    placeholder: "Role",
    key: "role",
    data_key: "supporting_data.roles",
  },


]

